  export const dqidOptions = [
    {id: 1, name: "Any" },
    {id: 2, name: "1-9 days" },
    {id: 3, name: "10-19 days" },
    {id: 4, name: "20-29 days" },
    {id: 5, name: "30-39 days" },
    {id: 6, name: "40-49 days" },
    {id: 7, name: "50-59 days" },
    {id: 8, name: "60-89 days" },
    {id: 9, name: "90+ days" },
    {id: 10, name: "Repoed" },
    {id: 11, name: "1-5 days" },
    {id: 12, name: "6-10 days" },
    {id: 13, name: "11-15 days" },
    {id: 14, name: "16-20 days" },
    {id: 15, name: "21-25 days" },
    {id: 16, name: "26-30 days" },
    {id: 17, name: "31-35 days" },
    {id: 18, name: "36-40 days" },
    {id: 19, name: "41-45 days" },
    {id: 20, name: "46-50 days" },
  ];

  export const extEligibilityOptions = [
    { id: 1, name: "Any" },
    { id: 2, name: "Yes" },
    { id: 3, name: "No" },
  ];

  export const aiOptions = [
    { id: 0, name: "No" },
    { id: 1, name: "Yes" },
  ];

  export const channelOptions = [
    { id: 1, name: "Texts" },
    { id: 2, name: "Emails" },
/*     { id: 3, name: "Text Messages & Emails" },
    { id: 4, name: "Outgoing Calls" },
    { id: 5, name: "Text Messges & Calls" },
    { id: 6, name: "Emails & Calls" }, */
  ];

  export const msgtimeOptions = [
    { id: null, name: "None" },
    { id: 1,  name: "6:00 AM" },
    { id: 2,  name: "6:30 AM" },
    { id: 3,  name: "7:00 AM" },
    { id: 4,  name: "7:30 AM" },
    { id: 5,  name: "8:00 AM" },
    { id: 6,  name: "8:30 AM" },
    { id: 7,  name: "9:00 AM" },
    { id: 8,  name: "9:30 AM" },
    { id: 9,  name: "10:00 AM" },
    { id: 10, name: "10:30 AM" },
    { id: 11, name: "11:00 AM" },
    { id: 12, name: "11:15 AM" },
    { id: 13, name: "11:30 AM" },
    { id: 14, name: "11:45 AM" },
    { id: 15, name: "12:00 PM" },
    { id: 16, name: "12:15 PM" },
    { id: 17, name: "12:30 PM" },
    { id: 18, name: "12:45 PM" },
    { id: 19, name: "1:00 PM" },
    { id: 20, name: "1:30 PM" },
    { id: 21, name: "2:00 PM" },
    { id: 22, name: "2:30 PM" },
    { id: 23, name: "3:00 PM" },
    { id: 24, name: "3:30 PM" },
    { id: 25, name: "4:00 PM" },
    { id: 26, name: "4:30 PM" },
    { id: 27, name: "5:00 PM" },
    { id: 28, name: "5:30 PM" },
    { id: 29, name: "5:35 PM" },
    { id: 30, name: "5:40 PM" },
    { id: 31, name: "5:45 PM" },
    { id: 32, name: "5:50 PM" },
    { id: 33, name: "5:55 PM" },
    { id: 34, name: "6:00 PM" },
    { id: 35, name: "6:05 PM" },
    { id: 36, name: "6:10 PM" },
    { id: 37, name: "6:15 PM" },
    { id: 38, name: "6:20 PM" },
    { id: 39, name: "6:25 PM" },
    { id: 40, name: "6:30 PM" },
    { id: 41, name: "6:45 PM" },
    { id: 42, name: "7:00 PM" },
    { id: 43, name: "7:15 PM" },
  ]; 

  export const repeatOptions = [
    { id: 1, name: "Repeat every week" },
    { id: 2, name: "Repeat every 2 weeks" },
    { id: 3, name: "Repeat every 3 weeks" },
    { id: 4, name: "Repeat every 4 weeks" },
    { id: 5, name: "Repeat every 5 weeks" },
    { id: 6, name: "Repeat every 6 weeks" },
    { id: 7, name: "Repeat every 2 months" },
    { id: 8, name: "None" },
  ];

  export const variableOptions = [
    { id: 1, name: "#firstname", description: "First name" },
    { id: 2, name: "#lastname", description: "Last name" },
    { id: 3, name: "#totalamountdue", description: "Total amount due" },
    { id: 4, name: "#monthlypayment", description: "Monthly payment" },
    { id: 5, name: "#rollamt", description: "Roll amount" },
    { id: 6, name: "#extamt", description: "Extension amount" },
    { id: 7, name: "#exteligible", description: "Extension eligibilty (yes/no)" },
    { id: 8, name: "#repoamt", description: "Repo amount" },
    { id: 9, name: "#repodate", description: "Repo date" },
    { id: 10, name: "#cclast4digits", description: "Last four digits of CC" },
    { id: 11, name: "#vehicleownamt", description: "Total vehicle ownership amount" },
    { id: 12, name: "#customerphonenumber", description: "Phone number" },
  ];